// extracted by mini-css-extract-plugin
export default {"fr-view":"Empty_fr-view__N+ZaV","container":"Empty_container__VG+nW","image":"Empty_image__7iUkr"};